export const isSecretString = (str: string): boolean => str.includes('*');
